/**
 * useCAPA – QMS Phase 5
 * Hook for CAPA (Corrective and Preventive Actions) list and mutations.
 */

import { useState, useEffect, useCallback } from 'react';
import { capaService } from '../services/capaService';

export function useCAPA(organizationId) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({});

  const fetch = useCallback(async () => {
    if (!organizationId) {
      setItems([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const list = await capaService.listByOrganization(organizationId, filters);
      setItems(list);
    } catch (err) {
      setError(err);
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, [organizationId, JSON.stringify(filters)]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  const create = async (data, userId) => {
    const id = await capaService.create({ ...data, organizationId }, userId);
    await fetch();
    return id;
  };

  const update = async (id, updates, userId) => {
    await capaService.update(id, updates, userId);
    await fetch();
  };

  const remove = async (id, userId) => {
    await capaService.delete(id, userId);
    await fetch();
  };

  const updateActionStatus = async (capaId, actionId, newStatus, uid) => {
    await capaService.updateActionStatus(capaId, actionId, newStatus, uid);
    await fetch();
  };

  const addEvidence = async (capaId, evidenceRef, uid) => {
    await capaService.addEvidence(capaId, evidenceRef, uid);
    await fetch();
  };

  return {
    items,
    loading,
    error,
    filters,
    setFilters,
    refetch: fetch,
    create,
    update,
    remove,
    updateActionStatus,
    addEvidence
  };
}
